import { byAttrVal, createCustomElement, DOMModel, registerEvent } from '@adobe/react-webcomponent'
import { ModalContextProvider } from '@billy/design-system'
import React, { ReactElement } from 'react'
import { QueryClientProvider } from 'react-query'
import { BrowserRouter as Router } from 'react-router'

import { BankIntegrationContextProvider } from '@features/openBanking/contexts/bankIntegrationContext'
import { AccountsContextProvider } from '@modules-deprecated/app/accounts'
import {
  UserOrganizationContextProvider,
  UserOrganizationSettingsContextProvider,
} from '@modules-deprecated/app/organization'
import { CurrentUserContextProvider } from '@modules-deprecated/app/user'
import { BankReconciliationTopActions } from '@views/reconciliation/elements/BankReconciliationTopActions'

import { queryClient } from '../../config/queryClient'
import { ThemeProvider } from '../../contexts/themeProvider'
import { EmberEventFn } from '../../types/emberEventFn'

const MODULE_NAME = 'bank-reconciliation-top-actions'

class BankReconciliationTopActionsWebComponent extends DOMModel {
  @byAttrVal accountId: string
  @byAttrVal organizationId: string
  @byAttrVal currentAccountName: string
  @registerEvent('changeReconcileStatus') changeReconcileStatus: EmberEventFn | undefined
}

type BankReconciliationTopActionsModuleProps = {
  accountId: string
  currentAccountName: string
  onChangeReconcileStatus: EmberEventFn
  organizationId: string
}

const BankReconciliationTopActionsModule = ({
  accountId,
  currentAccountName,
  onChangeReconcileStatus,
  organizationId,
}: BankReconciliationTopActionsModuleProps): ReactElement => {
  return (
    <ThemeProvider>
      <QueryClientProvider client={queryClient}>
        <Router>
          <UserOrganizationContextProvider organizationId={organizationId}>
            <UserOrganizationSettingsContextProvider organizationId={organizationId}>
              <CurrentUserContextProvider>
                <ModalContextProvider>
                  <AccountsContextProvider organizationId={organizationId}>
                    <BankIntegrationContextProvider account={accountId} organizationId={organizationId}>
                      <BankReconciliationTopActions
                        currentAccountName={currentAccountName}
                        onChange={onChangeReconcileStatus}
                      />
                    </BankIntegrationContextProvider>
                  </AccountsContextProvider>
                </ModalContextProvider>
              </CurrentUserContextProvider>
            </UserOrganizationSettingsContextProvider>
          </UserOrganizationContextProvider>
        </Router>
      </QueryClientProvider>
    </ThemeProvider>
  )
}

const BankReconciliationTopActionsCustomElement = createCustomElement(
  BankReconciliationTopActionsModule,
  BankReconciliationTopActionsWebComponent,
  'element',
)

customElements.get(MODULE_NAME) || customElements.define(MODULE_NAME, BankReconciliationTopActionsCustomElement)

export default BankReconciliationTopActionsCustomElement
